import { createEntityQuery } from '@datorama/akita';
import store from 'state/User/store';

export const query = createEntityQuery(store);
export const entities$ = query.selectAll();
export const activeEntity$ = query.selectActive();
export const activeEntityId$ = query.selectActiveId();
export const loading$ = query.selectLoading();
export const searchTerm$ = query.select('searchTerm');
